import React, {
  MouseEvent,
  useEffect,
  useState,
} from 'react';
import clsx from 'clsx';
import Popover from '@mui/material/Popover';
import Button from 'pages/Dashboard/components/Button';
import TemplateSelect from 'pages/Dashboard/components/TemplateSelect';
import {
  useGetMasterTemplateByName,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/hooks';
import {
  MasterTemplateDTO,
  TemplateListItemDTO,
} from 'dtos';
import {
  MasterTemplateIcon,
} from 'core/icons';

type Props = {
  disabled?: boolean;
  buttonText?: string;
  onApplyTemplate: (template: MasterTemplateDTO) => void;
};

export default function VisitNoteMasterTemplateButton({
  disabled,
  buttonText = 'Use Master Template',
  onApplyTemplate,
}: Props) {
  const [selectedTemplate, setSelectedTemplate] = useState<TemplateListItemDTO | null>(null);
  const { data: template } = useGetMasterTemplateByName(
    selectedTemplate?.templateName ?? undefined,
  );
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTemplateSelect = (selected: TemplateListItemDTO) => {
    setSelectedTemplate(selected);
    handleClose();
  };

  useEffect(() => {
    if (template) {
      onApplyTemplate(template);
      setSelectedTemplate(null);
    }
  }, [template, onApplyTemplate]);

  return (
    <>
      <Button
        className={clsx('!px-2.5 !py-0.5', {
          '!border-secondary nw-use-master-template-button': !disabled,
        })}
        variant="outlined"
        color="primary"
        type="button"
        disabled={disabled}
        onClick={handleClick}
      >
        <MasterTemplateIcon className="!mr-1.5 !h-4 !w-4" />
        {buttonText}
      </Button>
      <Popover
        id="existing-template-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        slotProps={{
          paper: {
            className: '!overflow-visible !shadow-lg',
          },
        }}
        anchorOrigin={{
          vertical: (anchorEl?.offsetHeight ?? 0) + 4,
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className="w-80 relative">
          <TemplateSelect onChange={handleTemplateSelect} />
        </div>
      </Popover>
    </>
  );
}
